module.exports = __webpack_public_path__ + "img/d5-active.9888feb5.png";